import React from 'react';
import PropTypes from 'prop-types';

import { UnmountClosed } from 'react-collapse';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import './Navigation.css';

import iterioLogo from 'images/logo.svg';

import { navConfig, groupedNavConfig, renderNavigationFromConf } from './config';
import Link from './Link';
import Burger from './Burger';

const dumbNavigation = dumbBem('landing-nav');

const Group = tx([{ element: 'group' }, dumbNavigation])('div');
const Logo = tx([{ element: 'logo' }, dumbNavigation])('img');

const Mobile = ({
  isOpened,
  toggleOpen,
}) => {
  return (
    <React.Fragment>
      <Group modifier="title">
        <Link exact to="/"><Logo src={iterioLogo} alt="Iterio logo" /></Link>
        <Burger isOpened={isOpened} onClick={toggleOpen} data-test="burger" />
      </Group>

      <UnmountClosed
        className="landing-nav__dropdown"
        fixedHeight={navConfig.length * 43 + 30}
        springConfig={{ stiffness: 210, damping: 20 }}
        isOpened={isOpened}
      >
        <Group modifier="links">
          {renderNavigationFromConf(groupedNavConfig.default, toggleOpen)}
        </Group>

        <Group modifier="signup">
          {renderNavigationFromConf(groupedNavConfig.auth)}
        </Group>
      </UnmountClosed>
    </React.Fragment>
  );
};

Mobile.propTypes = {
  isOpened: PropTypes.bool,
  toggleOpen: PropTypes.func.isRequired,
};

Mobile.defaultProps = {
  isOpened: false,
};

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/landing/components/navigation/Mobile.js